import styled from "@emotion/native";

import { SafeAreaView } from "react-native-safe-area-context";
import Text from "../../components/Text";

export const Container = styled(SafeAreaView)(
	{
		flex: 1,
		alignItems: "center",
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.background,
		};
	}
);
export const Logo = styled.View({
	height: 65,
	marginTop: 60,
	marginBottom: 30,
	alignItems: "center",
});

export const Caption = styled(Text)({
	alignItems: "center",
	marginBottom: 20,
});
